module.exports = __webpack_public_path__ + "img/protected-bag-icon-1.993230d8.svg";